import { Badge } from '@/components/ui/badge.jsx';

// Derived lifecycle status → Badge variant + label. Status strings come from
// the server (tapService.deriveTokenStatus): minted → programmed → handed_out
// → registered → claimed, with revoked terminal.
const MAP = {
  minted:     { variant: 'outline', label: 'Minted' },
  programmed: { variant: 'info',    label: 'Programmed' },
  handed_out: { variant: 'accent',  label: 'Handed out' },
  registered: { variant: 'success', label: 'Registered' },
  claimed:    { variant: 'success', label: 'Claimed' },
  revoked:    { variant: 'muted',   label: 'Revoked' },
};

export default function StatusPill({ status, className }) {
  const m = MAP[status] || MAP.minted;
  return <Badge variant={m.variant} className={className}>{m.label}</Badge>;
}
